<template>
  <div class="bottom">
    <div>联系我们</div>
    <div class="bottom-flex">
      <div class="bottom-flex-text">电话 ：024-25123111（工作日9:00—17:30）</div>
      <div class="bottom-flex-text">服务邮箱：Gongbaotong@yeah.net  </div>
      <div class="bottom-flex-text">地址：辽宁省沈阳市和平区南堤西路905号中海国际中心B座21层</div>
    </div>
    <div class="bottom-line"></div>
    <div class="bottom-flex">
      <div class="bottom-flex-text1">版权所有 © 2025 共保通（辽宁）数字科技发展有限公司</div>
      <!-- <div class="bottom-flex-text1">
        <img src="@/assets/image/head/icon3.png" style="margin-right: 6px;" />
        辽公网安备 21010202000955号
      </div> -->
      <div class="bottom-flex-text1" style="cursor: pointer;" @click="icpClick">
        <img src="@/assets/image/head/icon3.png" style="margin-right: 6px;" />
        辽ICP备2023009858号-5
      </div>
    </div>
    <div class="bottom-dowm">
      建议您使用Chrome谷歌浏览器
      <a href="https://www.google.cn/chrome/index.html" target="_blank">（<span
          style="text-decoration: underline;">点击下载</span>）</a>
      浏览本网站
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    icpClick() {
      window.open('https://beian.miit.gov.cn')
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/style/public.scss';
.bottom {
  width: 100%;
  height: 20.4rem;
  padding-top: 2.4rem;
  text-align: center;
  color: #ffffff;
  background-color: #061833;
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  font-size: 1.8rem;
  color: #FFFFFF;
  line-height: 1.8rem;
  box-sizing: border-box;

  .bottom-flex {
    display: flex;
    display: -webkit-box;
    display: -webkit-flex;
    justify-content: center;
    font-weight: 400;
    font-size: 1.4rem;
    color: #FFFFFF;

    .bottom-flex-text {
      margin: 2.4rem 1.5rem 0;
    }

    .bottom-flex-text1 {
      font-weight: 400;
      font-size: 1.2rem;
      color: #FFFFFF;
      margin: 2.4rem 1.5rem 0;
      display: flex;
      display: -webkit-box;
      display: -webkit-flex;
      align-items: center;
    }
  }

  .bottom-line {
    max-width: $mainWidth;
    width: 100%;
    height: 0px;
    margin: 2.4rem auto 0;
    border-top: 0.1rem solid #314665;
  }

  .bottom-dowm {
    font-weight: 400;
    font-size: 1.2rem;
    color: rgba(255, 255, 255, 0.6);
    margin-top: 1.2rem;
    margin-bottom: 2.4rem;

    a {
      color: rgba(255, 255, 255, 0.6);
      text-decoration: none;
    }
  }
}
</style>
